import type { HeaderMenusConfig } from '../../headerMenus.types.ts';
import { ROUTES } from './routes/routes.ts';

const navigationLinks: HeaderMenusConfig['navigationLinks'] = [
  {
    href: ROUTES.OFFERS,
    text: 'offers',
    trackName: 'Offers',
    icon: { name: 'discountTag', size: 'small', className: 'text-accent-red' },
    activePaths: ['/ob'],
  },
  { href: ROUTES.LOTTO.DISCOVERY, text: 'lotto', trackName: 'Lotto' },
  { href: ROUTES.CASINO.DISCOVERY, text: 'casino', trackName: 'Casino' },
  { href: ROUTES.LIVE_CASINO.DISCOVERY, text: 'live_casino', trackName: 'Live Casino' },
  { href: ROUTES.SCRATCHCARDS.DISCOVERY, text: 'scratchcards', trackName: 'Scratchcards' },
  { href: ROUTES.SPORTS.DISCOVERY, text: 'sports', trackName: 'Sports' },
];

const topMenuLinks: HeaderMenusConfig['topMenuLinks'] = [
  {
    labelKey: 'offers',
    icon: { name: 'discountTag', size: 'small', className: 'text-accent-red' },
    href: ROUTES.OFFERS,
    trackName: 'Offers',
    showNotification: true,
  },
  {
    labelKey: 'lotto',
    icon: { name: 'ticketStar', size: 'medium' },
    href: ROUTES.LOTTO.DISCOVERY,
    trackName: 'Lotto',
    showNotification: false,
  },
  {
    labelKey: 'casino',
    icon: { name: 'roulette', size: 'medium' },
    href: ROUTES.CASINO.DISCOVERY,
    trackName: 'Casino',
    showNotification: false,
  },
  {
    labelKey: 'live_casino',
    icon: { name: 'playingCards2', size: 'medium' },
    href: ROUTES.LIVE_CASINO.DISCOVERY,
    trackName: 'Live Casino',
    showNotification: false,
  },
  {
    labelKey: 'sports',
    icon: { name: 'sportBall', size: 'medium' },
    href: ROUTES.SPORTS.DISCOVERY,
    trackName: 'Sports',
    showNotification: false,
  },
  {
    labelKey: 'scratchcards',
    icon: { name: 'star', size: 'medium' },
    href: ROUTES.SCRATCHCARDS.DISCOVERY,
    trackName: 'Scratchcards',
    showNotification: false,
  },
];

const bottomMenuLinks: HeaderMenusConfig['bottomMenuLinks'] = [
  {
    labelKey: 'help_centre',
    icon: { name: 'help', size: 'medium' },
    href: ROUTES.HELP_CENTRE.BASE_URL,
    trackName: 'Help Centre',
  },
  {
    labelKey: 'whats_lotto_betting',
    icon: { name: 'infoCircle', size: 'medium' },
    href: ROUTES.FOOTER.NAVIGATION.INFORMATION.LOTTO_BETTING,
    trackName: 'Lotto Betting',
  },
  {
    labelKey: 'lottoland_blog',
    icon: { name: 'fileBookmark', size: 'medium' },
    href: ROUTES.FOOTER.NAVIGATION.LOTTERY.MAGAZINE,
    trackName: 'Blog',
  },
];
const headerMenus: HeaderMenusConfig = { bottomMenuLinks, navigationLinks, showsHamburgerMenuIcons: true, topMenuLinks };

export { headerMenus };
